import { createRouter, createWebHashHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    name: '主页',
    component: () => import('../views/layout'),
    // redirect:'/home',
    redirect:'/order',
    children:[
      // {
      //   path: '/home',
      //   name: '主页',
      //   component: () => import('../views/home')
      // },
      {
        path: '/user',
        name: '用户管理',
        component: () => import('../views/user')
      },
      {
        path: '/type',
        name: '产品分类',
        component: () => import('../views/type')
      },
      {
        path: '/product',
        name: '产品管理',
        component: () => import('../views/product')
      },
      {
        path: '/productModel',
        name: '产品型号',
        component: () => import('../views/productModel')
      },
      {
        path: '/order',
        name: '订单管理',
        component: () => import('../views/order')
      },
      {
        path: '/custom',
        name: '定制订单',
        component: () => import('../views/custom')
      },
      {
        path: '/productOrder',
        name: '订购订单',
        component: () => import('../views/productOrder')
      },
      {
        path: '/contactUs',
        name: '客户反馈',
        component: () => import('../views/contactUs')
      },
      {
        path: '/modifyPassword',
        name: '修改密码',
        component: () => import('../views/modifyPassword')
      },
    ]
  },
  {
    path: '/login',
    name: '登录',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/login')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
